import styled, { css } from 'styled-components';

import { IBasicStyledProps, keyframes } from '@notino/react-styleguide';

const adding = keyframes`
	0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
`;

interface IStyledPulsatingHeart extends IBasicStyledProps {
  animate: boolean;
  newPdDesignEnabled: boolean;
}

const complexMixin = css`
  animation: ${adding} 350ms ease forwards;
`;

export const StyledPulsatingHeart = styled.div`
  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? css`
          display: flex;
          align-items: center;
          padding-right: 1.13rem;
          padding-left: 0.125rem;
        `
      : css`
          padding-right: 1rem;
        `}

  svg {
    ${(props: IStyledPulsatingHeart) => (props.animate ? complexMixin : '')};
  }
`;
